import type { Reference } from 'fhir/r4';

import { getReferenceType } from '../mapping';
import type { ResourceType } from '../types';

export const filterReferencesByType = (
  resourceType: ResourceType,
  references: Reference[] = [],
): Reference[] =>
  references.filter((ref) => getReferenceType(ref) === resourceType);
